import '../../css/base.css';

const Finally = () => {

  return (
    <div>
      <h2 className="your-stay-section-heading">Finally</h2>
      <p className="your-stay-text"><strong>We wish you a very relaxing and enjoyable stay. We hope you enjoy our cottage as much as we do. If you would like to
                                    return in the future then please contact us directly as we will have some special offers for returning visitors and direct
                                    bookings.</strong>
      </p>                                            
    </div>
  );
}

export default Finally;